/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';
import { verifyMfaTokenPostRequestSchema } from './verifyMfaTokenPostRequestSchema.ts';
import { verifyMfaTokenPostResponseSchema } from './verifyMfaTokenPostResponseSchema.ts';

/**
 * @description 200 response
 */
export const postVerifyMfaToken200Schema = z.lazy(() => verifyMfaTokenPostResponseSchema);

/**
 * @description 505 response
 */
export const postVerifyMfaToken505Schema = z.any();

export const postVerifyMfaTokenMutationRequestSchema = z.lazy(() => verifyMfaTokenPostRequestSchema);

export const postVerifyMfaTokenMutationResponseSchema = z.lazy(() => postVerifyMfaToken200Schema);
